import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div className="bg-dark text-light p-3" style={{ minHeight: '100vh', width: '220px' }}>
      <h4 className="text-warning mb-4 fw-bold">Jewellery App</h4>

      <div className="nav flex-column">
        <NavLink to="/categories" className="btn btn-outline-warning mb-2 text-start">
          Categories
        </NavLink>
        <NavLink to="/subcategories" className="btn btn-outline-warning mb-2 text-start">
          Subcategories
        </NavLink>
        <NavLink to="/purity" className="btn btn-outline-warning mb-2 text-start">
          Purity
        </NavLink>
        <NavLink to="/counters" className="btn btn-outline-warning mb-2 text-start">
          Counters
        </NavLink>
        <NavLink to="/salespersons" className="btn btn-outline-warning mb-2 text-start">
          Salespersons
        </NavLink>
        <NavLink to="/commission" className="btn btn-outline-warning mb-2 text-start">
          Commission
        </NavLink>
        <NavLink to="/products" className="btn btn-outline-warning mb-2 text-start">
          Products
        </NavLink>
        <NavLink to="/billing" className="btn btn-outline-warning mb-2 text-start">
          Billing
        </NavLink>
        <NavLink to="/report" className="btn btn-outline-warning mb-2 text-start">
          Reports
        </NavLink>
        <NavLink to="/billing-report" className="btn btn-outline-warning mb-2 text-start">
          Billing Report
        </NavLink>
      </div>
    </div>
  );
};

export default Sidebar;
